export default __webpack_public_path__ + "static/media/chuks.03969d95.jpg";